import { useMutation, useQuery } from "@tanstack/react-query";
import {
  QuestionnaireRequestPushNotificationDto,
  RequestPushNotificationDto,
  SearchRequestPushNotificationDto,
} from "../../../services/dto";
import { IActionResponse, IActionResult } from "../../../assets/utils/lib";
import { PushNotificationClient } from "../../../services/proxies";

import { LookupDto } from "../../../assets/utils/lib/lookupDto";
import { Constants } from "../../../assets/utils/lib/constants";

export namespace PushNotificationService {
  const pushNotificationClient = new PushNotificationClient();

  export const save = () =>
    useMutation<
      IActionResult<RequestPushNotificationDto>,
      Error,
      RequestPushNotificationDto
    >({
      mutationFn: async (payload: RequestPushNotificationDto) => {
        return await pushNotificationClient.savePushNotificationAsync(payload);
      },
    });

  export const getPushNotificationQuery = (id: string | undefined) =>
    useQuery({
      queryKey: ["pushNotificationQuery", id],
      queryFn: async () =>
        await pushNotificationClient.getPushNotificationAsync(id),
      enabled: Boolean(id && id !== Constants.emptyGuid),
    });

  export const gridQuery = (searchQuery: SearchRequestPushNotificationDto) =>
    useQuery({
      queryKey: ["pushNotificationGridQuery", searchQuery],
      queryFn: async () =>
        await pushNotificationClient.searchPushNotificationAsync(searchQuery),
      enabled: Boolean(
        searchQuery.communityId &&
        searchQuery.communityId !== Constants.emptyGuid,
      ),
    });

  export const getLookups = () =>
    useQuery({
      queryKey: ["pushNotificationLookupsQuery"],
      queryFn: async () => await pushNotificationClient.getLookupsAsync(),
      select: (data) => {
        return {
          communities: LookupDto.mapToOptions(data?.communities),
          userCommunities: LookupDto.mapToOptions(data?.userCommunities),
          notificationType: LookupDto.mapToOptions(data?.notificationType),
          pageLink: LookupDto.mapToOptions(data?.pageLink),
          zipCodes: LookupDto.mapToOptions(data?.zipCodes),
        };
      },
    });

  export async function saveQuestionnairePushNotification(
    payload: QuestionnaireRequestPushNotificationDto,
  ): Promise<IActionResult<QuestionnaireRequestPushNotificationDto>> {
    return pushNotificationClient.saveQuestionnairePushNotificationAsync(
      payload,
    );
  }

  export const cancelPushNotification = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (id: string | undefined) => {
        return await pushNotificationClient.cancelPushNotificationAsync(id);
      },
    });

    export const deletePushNotification = () =>
        useMutation<IActionResponse, Error, string>({
            mutationFn: async (id: string | undefined) => {
                return await pushNotificationClient.deletePushNotificationAsync(id);
            },
        });
}
